// Republic Atlas - Main Layout Component

import { Outlet } from 'react-router-dom';
import { Header, Footer } from '@/components/navigation';
import { DevBanner } from '@/components/ui';
import { DebugPanel } from '@/components/dev';

export function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <DevBanner />
      <DebugPanel />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default MainLayout;

